module.exports = __webpack_public_path__ + "static/account-1.241c694b.png";